import { ComingSoon, Page } from "@lovehoa/site-theme";

/**
 * The temporary homepage: `apps/marketing-site` has no real content yet (Phase 2 of ROADMAP.md
 * builds it), so the shared dev marketing distribution — and eventually prod's — serves this
 * animated "coming soon" hero instead of an empty page. Swapping this out for real marketing
 * content later needs no infrastructure change, only a new component tree here.
 *
 * No sign-in affordance: `apps/portal`'s `/login` route (`docs/decisions/0005-marketing-portal-domain-split.md`)
 * does not exist yet, and this site is never allowed to construct a Hosted UI URL of its own.
 */
export function App() {
  return (
    <Page>
      <ComingSoon
        eyebrow="Coming Soon…"
        tagline="A product that helps neighbors Love their HOA"
        retainedWords={["Love", "HOA"]}
      />
    </Page>
  );
}
